<template>
  <div class="main">
    <!-- 主体内容 -->
    <router-view />
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class Main extends Vue {}
</script>

<style lang="scss" scoped>
.main {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.app-view {
  height: 100%;
  width: 100%;
  overflow: auto;
  padding: 14px 18px;
}
</style>
